'use client';

import React, {useEffect} from 'react';
import {Sizes} from '@sdk-mobile';

const ResizeListener: React.FC<{children: React.ReactNode}> = ({children}) => {
  useEffect(() => {
    // Start listening to resize events when the component mounts
    Sizes.startListening();

    // Stop listening to resize events when the component unmounts
    return () => {
      Sizes.stopListening();
    };
  }, []);

  return <>{children}</>;
};

export default ResizeListener;
